<template>
    <!-- <v-container>
        <v-row>
             <v-col md="9">
                 <google-map 
                    custom_title="Visualize stops" 
                    :realtime_tracking="true"
                    :simulated="simulatedDriver"
                />
            </v-col>
            <v-col md="3">
                <div class="text-center" v-if="loading">
                    <v-progress-circular 
                        :size="50"
                        color="primary"
                        indeterminate
                        style="margin:auto"
                    >
                    </v-progress-circular>
                </div>
                <v-data-table
                    :headers="headers.filter(h=>h.hide_in_table===undefined)"
                    :items="trackingData"
                    :loading="loading"
                    multi-sort
                    @click:row="row => simulateRow(row)"
                >
                </v-data-table>
            </v-col>
        </v-row>
    </v-container> -->

    <v-card>

<v-card-text class="d-flex flex-column">

    <v-form style="gap: 16px;" class="d-flex flex-row flex-sm-column flex-lg-row flex-x l-row">

        <div style="display: flex; flex-direction: column; width:100%; max-width: 800px;">

            <div style="padding: 0;">
                <v-col no-gutters>
                    <div class="upper-text body-2 mb-4 font-weight-medium">Station Stops</div>

                    <v-row no-gutters>
                        <v-col>
                <div class="text-center" v-if="loading">
                    <v-progress-circular 
                        :size="50"
                        color="primary"
                        indeterminate
                        style="margin:auto"
                    >
                    </v-progress-circular>
                </div>
                <v-data-table
                    :headers="headers.filter(h=>h.hide_in_table===undefined)"
                    :items="trackingData"
                    :loading="loading"
                    multi-sort
                    @click:row="row => simulateRow(row)"
                >
                </v-data-table>
            </v-col>
                    </v-row>
                </v-col>
            </div>

        </div>

        <div class="custom-divider"></div>

        <div style="display: flex; flex-direction: column; width:100%; gap: 16px;">

            <div style="gap: 16px; display: flex; flex-direction: column;" no-gutters>

                <v-col class="d-flex flex-column" style="justify-content: space-between; gap: 24px; padding: 0 12px"
                    no-gutters>

                    <div no-gutters style="padding: 0; height: fit-content;">

                        <v-row no-gutters>
                            <v-expansion-panels color="primary" accordion>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <v-row style="gap: 12px;" no-gutters>
                                            <div class="d-flex align-items-center"><v-icon color="primary">{{
                                                "mdi-map-outline" }}</v-icon></div>
                                            <div style="gap: 4px; display: flex; align-items: center;">
                                                <div class="upper-text body-2 font-weight-medium">Visualize stops</div>
                                            </div>
                                        </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div>              <v-col>
                 <google-map 
                    :realtime_tracking="true"
                    :simulated="simulatedDriver"
                    :driverStops="linePoints"
                />
            </v-col></div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>

                    </div>

                    <!-- <v-row no-gutters>

                        <v-col md="12">
                            <div class="text-center" v-if="loading">
                                <v-progress-circular :size="50" color="primary" indeterminate style="margin:auto">
                                </v-progress-circular>
                            </div>
                            <v-data-table 
                                :headers="headers.filter(h => h.hide_in_table === undefined)"
                                :items="trackingData" 
                                :loading="loading"
                                v-if="!reload && trackingData !== undefined && trackingData.length > 0" multi-sort>
                            </v-data-table>
                            <p v-else>
                                No tracking data found
                            </p>
                        </v-col>

                    </v-row> -->


                </v-col>

            </div>


        </div>

    </v-form>

</v-card-text>

</v-card>


</template>
<script>
import GoogleMap from '../GoogleMap'
import {mapActions} from 'vuex'
export default {
    components:{GoogleMap},
    props:['driver_id','driver','truck_id','truck',
    'delivery_address_id','delivery_address'],
    data() {  
        return {
            loading:false,
            trackingData:this.driver !== undefined? this.driver.driverStops : [],
            linePoints: [],
            reload:false,
            driverId:this.driver_id !== undefined? this.driver_id: 0,
            truckId:this.truck_id !== undefined? this.truck_id : 0,
            deliveryAddressId:this.delivery_address_id !== undefined? this.delivery_address_id:0,
            simulatedDriver:{
                coordinate : {
                    lat:0,
                    lng:0
                }
            },
            headers:[
                {
                    text:"Latitude",
                    value:"lat"
                },
                {
                    text:"Longitude",
                    value:"lng"
                },
                {
                    text:"Created Date",
                    value:"created"
                },
                // {
                //     text:"Client Id",
                //     value:"clientId"
                // }
            ]
        }
    },
    methods: {
        ...mapActions('entities',['getEntities']),
        simulateRow(stop) {  
            this.simulatedDriver.coordinate.lat = stop.lat
            this.simulatedDriver.coordinate.lng = stop.lng
        },
        simulateStops() {
            this.trackingData = this.trackingData.filter(d => d.lng !== undefined && d.lat !== undefined)
            this.trackingData.forEach(element => {
                var lat = parseFloat(element.lat)
                var lng = parseFloat(element.lng)
                if (lat !== 0 && lng !== 0) {
                    this.linePoints.push({
                        coordinate: {
                            lat: parseFloat(element.lat),
                            lng: parseFloat(element.lng)
                        }
                    })
                }
            });
        },
        
    },
    mounted() {  
        this.getEntities('driver');
        this.simulateStops(); 
    }
}
</script>